import createSelectors from './createSelectors';
import ChartDataProvider from '../models/ChartDataProvider';

const Select = createSelectors(ChartDataProvider, {});

export default Select;
